import React from 'react';
import styled from "styled-components";

const Logo = ({full}) => {
    return (
        <Container>
            <div className="logo-container">
                {!full ?
                    <div className="logo-name-container">
                        <h2>M</h2>
                        <h2>M</h2>
                    </div>
                    :
                    <div className="logo-name-container">
                        <h2>Msn</h2>
                        <h2>FM</h2>
                    </div>}
            </div>
        </Container>
    );
};

export default Logo;

const Container = styled.div`
  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  .logo {
    color: #7269ef;
    font-size: 1.7rem;
  }

  .logo-name-container {
    display: flex;
    flex-direction: row-reverse;

    h2:last-child {
      color: #7269ef;
      translate: 11px -6px;

    }

    h2:first-child {
      color: #495057;
      translate: -11px 6px;
      transform: scale(1, -1)
    }
  }
`;